<template>
  <div class="VoucherSliderCard">
    <aw-img
      :image="voucher.image"
      src="https://dummyimage.com/1400x930.jpg"
      class="rounded-ambi"
      size="1400x830x8"
    />
  </div>
</template>

<script>
export default {
  name: 'VoucherSliderCard',
  props: {
    voucher: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
